export const isAuthPage = (location) => {
    if(['/forgot-password', '/login', '/request-invitation', '/create-your-business-account', '/create-your-business-account/form', '/signup', '/create-your-user-account'].indexOf(location) !== -1 || location.indexOf('/reset-password/') !== -1 ||location.indexOf('/invitation/') !== -1) {
        return true;
    }
    return false;
};

export const formatNumber = (nbr) => {
    return new Intl.NumberFormat().format(nbr);
};

export const stripNonNumericCharacters = (str) => {
    return str.replace(/\D/g,'');
};

export const renderSpecializationString = (user) => {
    if(!user) {
        return null;
    }

    let specArray = [];

    if(user.primarySpecialization) {
        specArray.push(user.primarySpecialization.name);
    }

    if(user.secondarySpecialization) {
        specArray.push(user.secondarySpecialization.name);
    }

    return specArray.join(', ');
};

export const sortObjectsByLabel = (a, b) => {
    if (a.label.toLowerCase() < b.label.toLowerCase())
        return -1;
    if (a.label.toLowerCase() > b.label.toLowerCase())
        return 1;
    return 0;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js